import { render, staticRenderFns } from "./GroupsItem.vue?vue&type=template&id=fce2951c"
import script from "./GroupsItem.vue?vue&type=script&lang=js"
export * from "./GroupsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports